<template>
    <div v-show="pending"
        class="flex w-full flex-col items-start xl:ml-xl">
        <div class="flex flex-row items-start justify-start">
            <template v-for="i in 3"
                :key="i">
                <v-placeholder class="h-[34px] w-[49px] rounded bg-gray-50 via-gray-100" />
            </template>
        </div>

        <v-placeholder class="mt-2 h-4 w-60 rounded bg-gray-50 via-gray-100" />
    </div>

    <div v-show="!pending">
        <template v-if="promotionInfo.activeTo">
            <!-- Regular timer-->
            <v-page-product-countdown-timer v-show="properties.promotionInfo.showEndingTimer
                                                && (!properties.promotionInfo.isTimedVisibility || isWithin48Hours)"
                :active-to="promotionInfo.activeTo" />
        </template>

        <p>
            <span v-if="promotionInfo.showCountdownTextContent"
                class="mb-xs text-wrap text-sm font-bold">
                {{ activeToWithContent }}
            </span>

            <button v-if="promotionInfo.isCampaignModalEnabled"
                type="button"
                @click="isDiscountsOpen = !isDiscountsOpen">
                <span class="text-wrap text-sm font-bold underline">
                    {{ promotionInfo.campaignModalContent }}
                </span>
            </button>

            <template v-else>
                &nbsp;
                <span class="text-wrap text-sm font-bold">{{ promotionInfo.campaignModalContent }}</span>
            </template>
        </p>
    </div>

    <v-discounts-modal :is-open="isDiscountsOpen"
        :options="{isModal: true}"
        @close="isDiscountsOpen = false" />
</template>

<script setup lang="ts">
interface PromotionInfo {
    activeTo?: Date
    hidePriceHistory: boolean
    showEndingTimer: boolean
    showCountdownTextContent: boolean
    promotionTimerContent: string
    isTimedVisibility: boolean
    isCampaignModalEnabled: boolean
    campaignModalContent: string
}
const properties = defineProps<{
    pending: boolean
    promotionInfo: PromotionInfo
}>();

const isDiscountsOpen = ref(false);

const regex = /#date/i;

const activeToWithContent = computed<string>(() => (
    properties.promotionInfo.promotionTimerContent
        .replace(
            regex,
            properties.promotionInfo.activeTo?.toLocaleDateString(['fi-FI']) || '',
        )
));

const isWithin48Hours = computed(() => {
    const now = new Date();
    const timeDifference = (properties.promotionInfo.activeTo ?? new Date()).getTime() - now.getTime();
    const hoursDifference = timeDifference / (1000 * 60 * 60);

    return hoursDifference > 0 && hoursDifference <= 48;
});
</script>
